import { Download, Star } from "lucide-react";
import React, { useEffect, useState } from "react";

import {
  detectDevice,
  getAppStoreUrl,
  getDownloadButtonText,
  trackDownloadWithDevice,
} from "../utils/deviceDetection";

interface AppHeaderProps {
  onDownloadClick?: () => void;
}

const AppHeader: React.FC<AppHeaderProps> = ({ onDownloadClick }) => {
  const [deviceInfo, setDeviceInfo] = useState({
    deviceType: "desktop" as "ios" | "android" | "desktop",
    appStoreUrl: "https://apps.apple.com/vn/app/locuno/id6753800628",
    buttonText: { full: "Tải Xuống", short: "Tải Xuống" },
  });

  useEffect(() => {
    const device = detectDevice();
    const url = getAppStoreUrl(device.deviceType);
    const text = getDownloadButtonText(device.deviceType);

    setDeviceInfo({
      deviceType: device.deviceType,
      appStoreUrl: url,
      buttonText: text,
    });
  }, []);

  const handleDownloadClick = () => {
    // Track with device info
    trackDownloadWithDevice(deviceInfo.deviceType);

    // Call original callback if provided
    if (onDownloadClick) {
      onDownloadClick();
    }
  };

  return (
    <section className="bg-white rounded-xl md:rounded-2xl shadow-lg p-4 md:p-6 mb-6 md:mb-8 sticky top-20 z-40">
      <div className="flex items-center gap-6">
        {/* App Icon */}
        <div className="flex-shrink-0">
          <img
            src="/logo/icon-full-color.png"
            alt="Locuno Community Hub"
            className="w-24 h-24 sm:w-28 sm:h-28 md:w-36 md:h-36 "
          />
        </div>

        {/* App Info */}
        <div className="flex-1 min-w-0">
          <div className="flex flex-col sm:flex-row sm:items-start gap-1 sm:gap-2 mb-1">
            <h1 className="text-lg sm:text-xl md:text-2xl font-bold text-black leading-tight">
              Locuno - Kết Nối Hàng Xóm
            </h1>
          </div>

          <p className="text-gray-600 mb-1 text-sm">
            Cánh cửa kết nối cộng đồng - Mua bán, kết bạn, và khám phá sự kiện
            ngay tại khu phố của bạn!
          </p>
          {/* <p className="text-[#007AFF] font-medium mb-2 text-sm">Huynh Thang</p> */}
          {/* <p className="text-gray-600 mb-3 text-xs">Designed for iPad</p> */}

          {/* Rating */}
          <div className="flex items-center gap-2 mb-3">
            <div className="flex items-center">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className="w-3 h-3 fill-orange-400 text-orange-400"
                />
              ))}
            </div>
            <span className="text-xs text-gray-600">4.8</span>
            <span className="text-xs text-gray-400">•</span>
            <span className="text-xs text-gray-600">127 đánh giá</span>
          </div>

          <p className="text-lg font-semibold text-black mb-3">Miễn phí</p>

          {/* Download Button */}
          <a
            href={deviceInfo.appStoreUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleDownloadClick}
            className="inline-flex items-center gap-2 bg-[#007AFF] text-white px-6 py-2.5 rounded-full font-medium hover:bg-[#0056CC] transition-colors text-sm"
          >
            <span className="hidden sm:inline">
              {deviceInfo.buttonText.full}
            </span>
            <span className="sm:hidden">{deviceInfo.buttonText.short}</span>
            <Download className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default AppHeader;
